import { bool } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Button from 'ravenjs/lib/Button';

import MESSAGES from 'constants/messages';

const LoginFormActionsStyled = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 45px;
`;

const ButtonStyled = styled(Button)`
    font-size: 20px;
    ${({ theme }) => theme.media.down('md')`
        width: 100%;
    `};
`;

const LoginFormActions = ({ disabled }) => (
    <LoginFormActionsStyled>
        <ButtonStyled width="320px" minHeight="60px" disabled={disabled} type="submit">
            {MESSAGES.LOGIN.BUTTONS.SIGN_IN}
        </ButtonStyled>
    </LoginFormActionsStyled>
);

LoginFormActions.propTypes = {
    disabled: bool,
};

LoginFormActions.defaultProps = {
    disabled: false,
};

export default LoginFormActions;
